import { createSlice } from '@reduxjs/toolkit'
import { DataList } from '../common'
import { fetchMedia, createMedia, modifyMedia, deleteMedia, fetchMediaEngineStats } from './mediaAPI'
import type { Media, MediaState } from './types'
import {
  selectIdReducer,
  unselectIdReducer,
  openModalReducer,
  closeModalReducer,
  dismissErrorReducer,
  buildExtraReducers
} from './mediaReducer'

const initialState: MediaState = {
  sort: { column: 'id', order: 'desc' },
  selectedIds: [],
  openedModal: null,
  engineStats: null,
  ...DataList.initialState,
  data: [] as Media[],
  errors: {}
}

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    selectColumn: DataList.selectColumn,
    selectPage: DataList.selectPage,
    selectId: selectIdReducer,
    unselectId: unselectIdReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    dismissError: dismissErrorReducer
  },
  extraReducers: (builder) =>
    buildExtraReducers(builder, { fetchMedia, createMedia, modifyMedia, deleteMedia, fetchMediaEngineStats })
})

export const { selectColumn, selectPage, selectId, unselectId, openModal, closeModal, dismissError } =
  mediaSlice.actions
